var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 0C14.8829 0 19.1667 4.47 19.1667 10C19.1667 15.53 14.8829 20 9.58333 20C4.28375 20 0 15.53 0 10C0 4.47 4.28375 0 9.58333 0ZM13.0238 5L9.58333 8.59L6.14292 5L4.79167 6.41L8.23208 10L4.79167 13.59L6.14292 15L9.58333 11.41L13.0238 15L14.375 13.59L10.9346 10L14.375 6.41L13.0238 5Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3e7b23f26b29f25685763b19c2dbe32c.svg";
export { ForwardRef as ReactComponent };